import { Container } from '../../../odie';

import { VirusBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'virus/block.virus.png',
};

/*
    virus block view
*/
export class VirusBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: VirusBlockProps) {
    // spawn
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
